import { ColumnTitleContainer, ColumnTitleLabel } from 'components/KanbanBoard/columns/styled';
import { ColumnHeaderProps } from 'components/KanbanBoard/types';

const ColumnTitle = ({
    title,
    column,
    cards = [],
}: ColumnHeaderProps) => (
    <ColumnTitleContainer>
        <ColumnTitleLabel removable={column.removable}>{title}</ColumnTitleLabel>
        {cards.length}
    </ColumnTitleContainer>
);

export default ColumnTitle;
